<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="COPYRIGHT">Wm. B. Eerdmans Publishing Co.<br/>2140 Oak Industrial Drive N.E., Grand Rapids, Michigan 49505 /<br/>P.O. Box 163, Cambridge <span class="scall">CB3 9PU</span> U.K. <br/><a href="http://www.eerdmans.com" target="_blank">www.eerdmans.com</a><br/><br/>© 1992 N. T. Wright<br/>All rights reserved<br/>First U.K. edition published 1992 by<br/>Society for Promoting Christian Knowledge<br/>36 Causton Street, London <span class="scall">SW1P 4ST</span><br/>First American edition published 1993 by<br/>Wm. B. Eerdmans Publishing Co.<br/>New edition published 2014<br/><br/>Printed in the United States of America</p>
<p class="LIBRARY">Library of Congress Cataloging-in-Publication Data</p>
<p class="CIP">Wright, N. T. (Nicholas Thomas) Who was Jesus? / N. T. Wright. — 1st North American ed.<br/>p.   cm.<br/>Includes bibliographical references.<br/>ISBN 978-0-8028-7181-7<br/>eISBN 978-1-4674-3806-3 (ePub)<br/>eISBN 978-1-4674-0353-5 (Kindle)<br/>1. Jesus Christ — Biography — History and criticism. 2. Jesus Christ — Historicity. 3. Bible. N.T. Gospels — Criticism, interpretation, etc. <br/>4. Thiering, Barbara. Jesus the man. 5. Wilson, A. N., 1950–  Jesus.<br/>6. Spong, John Shelby. Born of a woman.   I. Title.<br/><br/>BT301.9.W75 1993<br/>232.9<span class="symbol">′</span>01 — dc20<br/>[B]        93-6747<br/>	CIP</p>
<p class="NRSV">Unless otherwise noted, scripture quotations are from the New Revised Standard Version of the Bible, copyright © 1989 by the Division of Christian Education of the National Council of the Churches of Christ in the U.S.A., and used by permission.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Copyright.vue?2a0a97d2